import { render, staticRenderFns } from "./ReturnsTreated.vue?vue&type=template&id=b0978f06"
import script from "./ReturnsTreated.vue?vue&type=script&lang=js"
export * from "./ReturnsTreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports